(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-nested"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slideshow-playback')) {
    class SlideshowPlayback extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-slideshow-playback]');
        this.label = this.querySelector('[data-slideshow-playback-label]');
        this.slider = document.getElementById(this.button?.getAttribute('aria-controls'));
        this.slideshow = this.closest('.slideshow');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.button || !this.slider) return;

        this.handleClick = this.handleClick.bind(this);
        this.handleReducedMotion = this.handleReducedMotion.bind(this);
        this.handleSliderLoaded = this.handleSliderLoaded.bind(this);
        this.button.addEventListener('click', this.handleClick);
        this.reduceMotion.addEventListener('change', this.handleReducedMotion);
        this.slideshow?.addEventListener('theme:slider:loaded', this.handleSliderLoaded);

        if (this.reduceMotion.matches) {
          this.setPaused(true);
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        this.reduceMotion?.removeEventListener('change', this.handleReducedMotion);
        this.slideshow?.removeEventListener('theme:slider:loaded', this.handleSliderLoaded);
      }

      handleClick() {
        const shouldPause = this.button.getAttribute('aria-pressed') !== 'true';
        this.setPaused(shouldPause);

        if (shouldPause) {
          this.slider.flkty?.stopPlayer();
        } else {
          this.slider.flkty?.playPlayer();
        }
      }

      handleReducedMotion(event) {
        if (!event.matches) return;

        this.setPaused(true);
        this.slider.flkty?.stopPlayer();
      }

      handleSliderLoaded() {
        if (this.button.getAttribute('aria-pressed') === 'true') {
          this.slider.flkty?.stopPlayer();
        }
      }

      setPaused(paused) {
        this.button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        this.label.textContent = paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause;
      }
    }

    customElements.define('slideshow-playback', SlideshowPlayback);
  }

  } catch(e) { console.error(e); }
})();
})();
